// @ts-strict-ignore
import {
	AdSlotClass,
	AdSlotStatus,
	communicationService,
	DiProcess,
	eventsRepository,
	utils,
} from '@wikia/ad-engine';
import { Injectable } from '@wikia/dependency-injection';
// eslint-disable-next-line no-restricted-imports
import { getAdType } from '@wikia/core/providers/functions/get-ad-type';

@Injectable()
export class ForcedCollapseHandler implements DiProcess {
	execute(): void {
		communicationService.on(eventsRepository.AD_ENGINE_CUSTOM_AD_LOADER_CALLED, () => {
			this.initCollapseHandling();
		});
	}

	initCollapseHandling(): void {
		const tag = window.googletag.pubads();

		tag.addEventListener('slotRenderEnded', (event: googletag.events.SlotRenderEndedEvent) => {
			utils.defer(() => {
				const slotName = event.slot.getSlotElementId();
				const slotIframe = <HTMLIFrameElement | null>document.querySelector(`#${slotName} iframe`);

				const adType = getAdType(event, slotIframe);
				if (adType === 'forced_collapse') {
					this.collapseSlot(slotName);
				}
			});
		});
	}

	collapseSlot(slotName: string): void {
		const placeholderElement = document.querySelector(`#${slotName}`);
		if (placeholderElement === null) {
			return;
		}
		placeholderElement.classList.remove('ad__h50');
		placeholderElement.classList.remove('ad__h50--inner');
		placeholderElement.classList.add(AdSlotClass.HIDDEN_AD_CLASS);
		placeholderElement.setAttribute('data-slot-result', AdSlotStatus.STATUS_COLLAPSE);

		const parentPlaceholderElement = placeholderElement.parentElement;
		if (parentPlaceholderElement === null) {
			return;
		}
		parentPlaceholderElement.classList.remove('ad__h250');
	}
}
